class GoyuuHeroCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.slides = Array.from(this.querySelectorAll('[data-goyuu-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-goyuu-hero-dot]'));
    this.previousButton = this.querySelector('[data-goyuu-hero-prev]');
    this.nextButton = this.querySelector('[data-goyuu-hero-next]');
    this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 5000;
    this.timer = null;

    this.previousButton?.addEventListener('click', () => {
      this.pause();
      this.select(this.currentIndex - 1);
      this.start();
    });

    this.nextButton?.addEventListener('click', () => {
      this.pause();
      this.select(this.currentIndex + 1);
      this.start();
    });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.pause();
        this.select(index);
        this.start();
      });
    });

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.start());

    document.addEventListener('shopify:block:select', (event) => {
      const selectedSlide = event.target?.closest?.('[data-goyuu-hero-slide]');

      if (!selectedSlide || !this.contains(selectedSlide)) return;

      this.pause();
      this.select(this.slides.indexOf(selectedSlide));
    });

    this.select(this.currentIndex);
    this.start();
  }

  select(index) {
    if (this.slides.length === 0) return;

    const normalizedIndex = (index + this.slides.length) % this.slides.length;
    this.currentIndex = normalizedIndex;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === normalizedIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === normalizedIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', String(isActive));
    });
  }

  start() {
    this.pause();

    if (!this.autoplay || this.slides.length <= 1) return;

    this.timer = window.setInterval(() => {
      this.select(this.currentIndex + 1);
    }, this.autoplaySpeed);
  }

  pause() {
    if (!this.timer) return;

    window.clearInterval(this.timer);
    this.timer = null;
  }

  disconnectedCallback() {
    this.pause();
  }
}

if (!customElements.get('goyuu-hero-carousel')) {
  customElements.define('goyuu-hero-carousel', GoyuuHeroCarousel);
}
